import React from "react";
import { connect } from "react-redux";
import { IAppState } from "../state/interfaces";
import { QUOTE_STEPS } from "../AppConstants";
import { hasQuickQuoteDiscounts } from "../config/StateQuoteConfig";

interface IProps {
    progress: number,
    showDiscounts: boolean
}

class QuickProgress extends React.Component<IProps> {
    constructor(props: IProps) {
        super(props);
    }

    componentDidMount() {
    }

    render() {
        return (
            <div className="quote-progress">
                <div className="steps">
                    <div className="row step-names">
                        <div className={this.props.showDiscounts ? "col-3 text-center" : "col-4 text-center"}>Zip Code</div>
                        <div className={this.props.showDiscounts ? "col-3 text-center" : "col-4 text-center"}>Vehicles</div>
                        <div className={this.props.showDiscounts ? "col-3 text-center" : "col-4 text-center"}>Drivers</div>
                        {this.props.showDiscounts && <div className="col-3 text-center">Discounts</div>}
                    </div>
                    <div className="progress" style={{ height: 4 }}>
                        <div className="progress-bar" role="progressbar" style={{ width: this.props.progress + '%' }}></div>
                    </div>
                </div>
            </div>
        );
    }
}

function calculateProgress(currentStep: string, showDiscounts: boolean) {
    if (!showDiscounts) {
        switch (currentStep) {
            case QUOTE_STEPS.QUICK_ZIP:
                return 17;
            case QUOTE_STEPS.QUICK_VEHICLE:
                return 50;
            case QUOTE_STEPS.QUICK_DRIVER:
                return 84;
            default:
                return 0;
        }
    }

    switch (currentStep) {
        case QUOTE_STEPS.QUICK_ZIP:
            return 13;
        case QUOTE_STEPS.QUICK_VEHICLE:
            return 38;
        case QUOTE_STEPS.QUICK_DRIVER:
            return 62;
        case QUOTE_STEPS.QUICK_DISCOUNT:
            return 87;
        default:
            return 0;
    }
}

let mapProps = (state: IAppState) => {
    const showDiscounts = hasQuickQuoteDiscounts(state.stateCode);
    return {
        showDiscounts,
        progress: calculateProgress(state.currentStep, showDiscounts)
    }
}

let mapDispatch = (dispatch: any) => {
    return {
    }
}

export default connect(mapProps)(QuickProgress)
